/* eslint-disable react/destructuring-assignment,react/no-unescaped-entities,react/no-array-index-key */

import React from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import classNames from 'classnames';
import { email as emailValidation } from '../../../utilities/validation';
import { PortalButton } from '../../PortalButton/PortalButton';
import './MoreQualificationsModal.scss';

export class MoreQualificationsModal extends React.Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
  };

  static displayName = 'MoreQualificationsModal';

  static categories = [
    'Accounting & Finance',
    'Animal Care & Vet Nursing',
    'Beauty',
    'Building & Construction',
    'Business Administration & Management',
    'Community Services',
    'Design & Photography',
    'Education',
    'Health & Fitness',
    'Information Technology',
    'Logistics & Work Health & Safety',
    'Marketing, Events, Tourism & Hospitality',
    'Project Management',
    'Writing & Journalism',
  ];

  state = {
    email: '',
    other: '',
    selections: Immutable.Map(),
    errors: Immutable.Map(),
  };

  handleSubmit = () => {
    const { email, other, selections } = this.state;
    let errors = Immutable.Map();

    if (!email || emailValidation(email)) {
      errors = errors.set('email', 'Please enter a valid email address');
    }

    if (selections.size === 0) {
      errors = errors.set('selections', 'Please choose one or more categories');
    }

    if (selections.has('other') && !other) {
      errors = errors.set('other', 'Please enter a value');
    }

    this.setState(() => {
      return { errors };
    });
    if (errors.size === 0) {
      this.props.onSubmit({
        email,
        other: selections.has('other') ? other : null,
        selections: selections.toJS(),
      });
    }
  };

  updateSelection = (category, isChecked) => {
    let { selections } = this.state;
    if (isChecked) {
      selections = selections.set(category, true);
    } else if (selections.has(category)) {
      selections = selections.delete(category);
      if (category === 'other') {
        this.setState((prevState) => {
          return { errors: prevState.errors.delete('other') };
        });
      }
    }
    this.setState((prevState) => {
      return { selections, errors: prevState.errors.delete('selections') };
    });
  };

  updateOther = (event) => {
    const other = event.target.value;
    this.setState((prevState) => {
      return { other, errors: prevState.errors.delete('other') };
    });
  };

  updateEmail = (event) => {
    const email = event.target.value;
    this.setState((prevState) => {
      return { email, errors: prevState.errors.delete('email') };
    });
  };

  render() {
    const { selections, email, other, errors } = this.state;

    return (
      <more-qualifications-modal>
        <form>
          <h4>Quality Takes Time</h4>
          <p>
            That's why we're starting small. If you're looking for another
            qualification, register your interest and we'll let you know when it
            becomes available.
          </p>
          <ul className="categories-list">
            {MoreQualificationsModal.categories.map((category, index) => (
              <li key={index}>
                <label>
                  <input
                    type="checkbox"
                    checked={selections.has(category)}
                    onChange={(evt) =>
                      this.updateSelection(category, evt.target.checked)
                    }
                  />
                  {category}
                </label>
              </li>
            ))}
            <li>
              <label>
                <input
                  type="checkbox"
                  checked={selections.has('other')}
                  onChange={(evt) =>
                    this.updateSelection('other', evt.target.checked)
                  }
                />
                Other
              </label>
              <div className="input-wrapper">
                <input
                  type="text"
                  value={other}
                  onChange={this.updateOther}
                  disabled={!selections.has('other')}
                  className={classNames({
                    error: errors.has('other'),
                  })}
                />
                {errors.has('other') && (
                  <div className="error-msg">{errors.get('other')}</div>
                )}
              </div>
            </li>
          </ul>
          <div className="form-wrapper">
            <div className="input-wrapper">
              <input
                type="text"
                placeholder="Your Email"
                value={email}
                onChange={this.updateEmail}
                className={classNames({
                  error: errors.has('email'),
                })}
              />
              {errors.has('email') && (
                <div className="error-msg">{errors.get('email')}</div>
              )}
            </div>
            <div className="submit-wrapper">
              <PortalButton onClick={this.handleSubmit}>
                <span>Register your interest</span>
              </PortalButton>
              <div className="errors">
                {errors.has('selections') && (
                  <div className="error-msg">{errors.get('selections')}</div>
                )}
              </div>
            </div>
          </div>
        </form>
      </more-qualifications-modal>
    );
  }
}
